import {InputHTMLAttributes, PureComponent, Ref} from 'react';
import {join} from '@esgi/ui-kit/utils';
import {Omit} from 'react-beautiful-dnd';
import {Selectors} from '../controls.selectors';

import styles from './switch.module.less';

type BaseCheckboxAttributes = Omit<
	InputHTMLAttributes<HTMLInputElement>,
	'value' | 'checked' | 'type' | 'role'
>;

export type SwitchProps = {
	toggled: boolean;
	innerRef?: Ref<HTMLLabelElement>;
} & BaseCheckboxAttributes;

export class Switch extends PureComponent<SwitchProps> {
	private id = 'switch-' + Math.round(Math.random() * 10000);

	public override render() {
		const {className, children, id, toggled, innerRef, ...inputProps} =
			this.props;
		const inputID = id || this.id;
		return (
			<div className={join(styles.container, className)} data-name={inputID}>
				<label className={styles.switchEl} ref={innerRef}>
					<input
						id={inputID}
						type='checkbox'
						checked={toggled}
						data-cy={Selectors.Switch}
						style={{opacity: 0, width: 0, height: 0, marginRight: 40}}
						{...inputProps}
						role='switch'
					/>
					<span className={styles.slider}></span>
					{children}
				</label>
			</div>
		);
	}
}
export default Switch;
